import { $http } from "@/assets/js/appFunc";

export const testRule = (store, rulesToTest) => $http({
    url: "/engine/api/application/testrule",
    type: "POST",
    data: rulesToTest
}).then(rsp => {
    if (rsp && rsp.data) {
        store.commit("testedRules", rsp.data);
    }
});

export const instanceVariablesValues = (store, instanceRules) => new Promise((resolve) => {
    $http({
        url: "/engine/api/processDefinition/instancedata",
        type: "POST",
        data: instanceRules
    }, true).then(rsp => {
        resolve(rsp.data);
    }).catch(e => {
        console.log(e);
    });
});
